import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import Chip from '@material-ui/core/Chip';
import styles from '../ClientProfile/profile.module.scss';
import strings from '../../../strings';
import {formatDate} from "../ClientProfile/partial/billingTab";
import Button from "../../shared/Button";

export default function ChangePlanDialog({
  open,
  onClose,
  onConfirm,
  currentPlan,
  newPlan,
  creditsRemaining,
  nextBillingDate,
    loading
}) {

  function centsToUSD(amount) {
    return   !!amount ? `$${(amount/100).toLocaleString('en-US')}` : "$0";
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth disableEscapeKeyDown>
      <DialogTitle>{strings.BILLING.CHANGE_PLAN_TITLE}</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1" gutterBottom>
          {strings.BILLING.CHANGE_PLAN_SUBTITLE.replace('{planName}', newPlan?.product || '')}
        </Typography>
        <Box display="flex" mb={3} mt={2} style={{ gap: '1rem' }}>
          {/* Current Plan Box */}
          <Box position="relative" border={1} borderColor="#ccc" borderRadius={2} p={2} flex={1} minWidth={0}>
            {/* Savings Chip if available */}
            {currentPlan?.savings && (
              <Chip
                label={currentPlan.savings}
                className={styles.planBadgeSavings}
                style={{ position: 'absolute', top: 8, right: 8 }}
                color="primary"
                size="small"
              />
            )}
            <Typography variant="caption" color="textSecondary">{strings.BILLING.CHANGE_PLAN_CURRENT}</Typography>
            <Typography variant="body1" fontWeight={600}>{currentPlan?.product}</Typography>
            <Typography variant="body2" color="textSecondary">{centsToUSD(currentPlan?.priceAmount)}/{currentPlan?.interval}</Typography>
            <Typography variant="body2" mt={1}>{currentPlan?.description}</Typography>
          </Box>
          {/* New Plan Box */}
          <Box position="relative" border={1} borderColor="#ccc" borderRadius={2} p={2} flex={1} minWidth={0} style={{ background: '#F4F4F4' }}>
            {/* Savings Chip if available */}
            {newPlan?.savings && (
              <Chip
                label={newPlan.savings}
                className={styles.planBadgeSavings}
                style={{ position: 'absolute', top: 8, right: 8 }}
                color="primary"
                size="small"
              />
            )}
            <Typography variant="caption" color="textSecondary">{strings.BILLING.CHANGE_PLAN_NEW}</Typography>
            <Typography variant="body1" fontWeight={600}>{newPlan.product}</Typography>
            <Typography variant="body2" color="textSecondary">{centsToUSD(newPlan.priceAmount)}/{newPlan.interval}</Typography>
            <Typography variant="body2" mt={1}>{newPlan.description}</Typography>
          </Box>
        </Box>
        <Divider style={{ margin: '16px 0' }} />
        <Box mb={2}>
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            <li>
              <Typography variant="body2" component="span">
                Monthly billing starts immediately: <b>{centsToUSD(newPlan.priceAmount)}</b>
              </Typography>
            </li>
            <li>
              <Typography variant="body2" component="span">
                New credit purchases: <b>{centsToUSD(newPlan.pricePerCredit)}</b> each {newPlan.savings || ''}
              </Typography>
            </li>
            <li>
              <Typography variant="body2" component="span">
                Your existing <b>{creditsRemaining}</b> credits remain unchanged
              </Typography>
            </li>
            <li>
              <Typography variant="body2" component="span">
                Next billing date: <b>{formatDate(nextBillingDate || new Date(Date.now() + 30 * 24 * 60 * 60 * 1000))}</b>
              </Typography>
            </li>
          </ul>
        </Box>
      </DialogContent>
      <DialogActions style={{ padding: 16 }}>
        <Button onClick={onClose} color="primary" variant="text" disabled={loading}>
          {strings.BILLING.CHANGE_PLAN_CANCEL}
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained" loading={loading}>
          {strings.BILLING.CHANGE_PLAN_CONFIRM}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
